<template>
  <div class="el-region-selector">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1180px"
      :top="sta"
      :before-close="handleClose"
    >
      <div class="el-dialog-box">
        <ul>
          <li v-for="(item, index) in options" :key="index">
            <!--              <el-checkbox >{{item.name}}</el-checkbox>-->
            <el-checkbox
              :label="item.code"
              :key="index"
              name="type"
              :indeterminate="item.isIndeterminate"
              v-model="item.checked"
              @change="handleCheckedCitiesChangea(item)"
            >
              {{ item.name }}
            </el-checkbox>
            <i
              v-if="code.includes(item.code) ? astrict > 2 : astrict > 1"
              class="el-icon-arrow-down"
              style="cursor: pointer;"
              @click="show($event, item)"
            ></i>
          </li>
        </ul>
        <label class="quanXuan">
          <el-checkbox
            :label="titleAll"
            v-model="checkedAll"
            :indeterminate="isIndeterminateAll"
            name="type"
            @change="changeCheckedAll"
          ></el-checkbox>
        </label>
        <div
          v-if="showBox"
          class="show-parent"
          :style="{ left: tranLeft, top: tranTop }"
        >
          <div class="shard">
            <div
              class="show-inner"
              v-for="(item, index) in optionsa"
              :key="index"
            >
              <el-checkbox
                :label="item.code"
                :key="index"
                name="type"
                :indeterminate="item.isIndeterminate"
                v-model="item.checked"
                @change="handleCheckedCitiesChange2(item)"
              >
                {{ item.name }}
              </el-checkbox>
              <i
                v-if="code.includes(item.pcode) ? astrict > 3 : astrict > 2"
                class="icon-ccui-next"
                style="cursor: pointer;"
                @click="show2($event, item)"
              ></i>
            </div>
          </div>
        </div>
        <div
          v-if="showBox2"
          class="show-parent2"
          :style="{ left: tranLeft2, top: tranTop2 }"
        >
          <div class="shard">
            <div
              class="show-inner"
              v-for="(item, index) in optionsb"
              :key="index"
            >
              <el-checkbox
                :label="item.code"
                :key="index"
                name="type"
                v-model="item.checked"
                @change="handleCheckedCitiesChange3(item)"
              >
                {{ item.name }}
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="myCancel">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import Axios from "axios";
import Cookies from "js-cookie";
export default {
  name: "ElRegionSelector",
  props: {
    handleNodeClick: Function,
    checkedCitiesa: Array,
    loadNode: Function,
    areaData: Array,
    dialogVisible: Boolean,
    url: {
      type: String,
      default: ""
    },
    astrict: {
      type: Number,
      default: 3
    },
    headers: {
      type: Object,
      default: () => {
        return {
          APP_TOKEN: Cookies.get("appToken"),
          Authorization: Cookies.get("access_token")
        };
      }
    },
    title: {
      type: String,
      default: "选择区域"
    },
    titleAll: {
      type: String,
      default: "全选"
    },
    agentId: {
      type: String,
      default: ""
    }
  },
  watch: {
    dialogVisible() {
      console.log(this.areaData, "checkedCitiesa");
      if (
        (this.checkedCities4[0] && this.checkedCities4[0].pcode2 == "全国") ||
        (this.areaData[0] && this.areaData[0].areaDataName == "全国")
      ) {
        this.options.forEach(i => {
          i.checked = true;
          this.checkedAll = true;
        });
      }
      console.log(this.checkedCities4, "----------");
      this.visible = this.dialogVisible;
    },
    tranLeft() {
      this.showBox2 = false;
    },
    checkedCitiesa() {
      let obj = [];
      this.checkedCities4 = [...this.checkedCitiesa];
      this.checkedCitiesa.map(item => {
        obj.push(item.pcode2);
      });
      this.dataInitialized(obj);
      this.getAddressOfFourth();
    }
  },
  data() {
    return {
      code: ["1", "2", "3", "4"],
      checkedCities: [],
      checkedCities3: [],
      checkedCities2: this.checkedCitiesa,
      checkedCities4: [...this.checkedCitiesa],
      isIndeterminate: true,
      isIndeterminateAll: false,
      options: [],
      optionsa: [],
      optionsb: [],
      checkedAll: false,
      showBox: false,
      showBox2: false,
      tranLeft: 0,
      tranLeft2: 0,
      tranTop2: 0,
      tranTop: 0,
      props: {
        multiple: true,
        value: "name",
        label: "name"
      },
      state: "",
      sta: "5vh",
      checkModel: [true],
      restaurants: [],
      addRestaurants: [],
      timeout: null,
      isShow: true,
      isShows: true,
      visible: false,
      checkAll: false,
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  created() {
    let obj = [];
    this.checkedCities2.map(item => {
      obj.push(item.pcode2);
    });
    this.dataInitialized(obj);
    this.getAddressOfFourth(this.checkedCities2);
  },
  methods: {
    unique(arr) {
      // 根据唯一标识orderId来对数组进行过滤
      const res = new Map(); // 定义常量 res,值为一个Map对象实例
      // 返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter(arr => !res.has(arr.code) && res.set(arr.code, 1));
    },
    deduoe(array) {
      return Array.from(new Set(array));
    },
    dataInitialized(data) {
      this.checkedCities = data;
      this.checkedCities3 = data;
      let obj3 = [];
      if (data.length === 0) obj3 = [];
      data.map(item => {
        if (item.split("-").length === 1) {
          let obj2 = {};
          obj2.capital = item.split("-")[0];
          obj3.push(obj2);
        }
        if (item.split("-").length === 2) {
          let obj2 = {};
          obj2.capital = item.split("-")[0];
          obj2.city = item.split("-")[1];
          obj3.push(obj2);
        }
        if (item.split("-").length === 3) {
          let obj2 = {};
          obj2.capital = item.split("-")[0];
          obj2.city = item.split("-")[1];
          obj2.district = item.split("-")[2];
          obj3.push(obj2);
        }
      });
      this.checkedCities2 = obj3;
    },
    getAddressOfFourth() {
      Axios({
        method: "post",
        url: this.url,
        headers: this.headers,
        data: {
          code: "0",
          agentId: this.agentId
        }
      }).then(res => {
        if (!Array.isArray(res.data.data)) {
          res.data.data = res.data.data.addressList;
        }
        this.options = res.data.data;
        this.options.map(item => {
          item.checked = false;
          item.isIndeterminate = false;
          item.pcode2 = item.code + "";
          item.code = item.code + "";
          item.cityName = item.name + "";
          this.checkedCities2.map(e => {
            if (e.capital === item.code && e.city === undefined) {
              item.checked = true;
              this.checkedCities4.push(item);
            }
            if (e.capital === item.code && e.city !== undefined) {
              item.isIndeterminate = true;
            }
            this.isIndeterminateAll = true;
          });
        });
        console.log(this.checkedAll);
        if (this.checkedAll) {
          this.options.map(item => (item.checked = true));
        }
        this.checkedCities4 = this.unique(this.checkedCities4);
      });
    },
    clone(origin) {
      let originProto = Object.getPrototypeOf(origin);
      return Object.assign(Object.create(originProto), origin);
    },
    getAddress(data) {
      Axios({
        method: "post",
        url: this.url,
        headers: this.headers,
        data: {
          code: data.code,
          agentId: this.agentId
        }
      }).then(res => {
        if (!Array.isArray(res.data.data)) {
          res.data.data = res.data.data.addressList;
        }
        // let name = ['北京', '天津', '重庆', '上海'];
        // if (name.includes(data.name)) {
        //   let obj = this.clone(data);
        //   obj.name1 = '直辖市';
        //   obj.level = 2;
        //   res.data.data = [... obj];
        // }
        // if (data.name1 === '直辖市') {
        //   res.data.data.map(e =>{
        //     return e.level = e.level + 1;
        //   })
        // }
        if (res.data.data.length === 0) {
          this.showBox = false;
        } else if (res.data.data[0].level === 2) {
          console.log(11111);
          this.optionsa = res.data.data;
          this.optionsa.map(item => {
            item.code = item.code + "";
            item.pcode = item.pcode + "";
            if (data.checked === true) {
              item.checked = true;
              item.isIndeterminate = false;
            } else {
              item.isIndeterminate = false;
              item.checked = false;
            }
            this.options.map(s => {
              if (s.code === item.pcode) {
                item.pcode2 = s.code + "-" + item.code;
                item.cityName = s.name + item.name;
              }
            });
            this.checkedCities2.map(e => {
              if (e.city === item.code && e.district === undefined) {
                item.checked = true;
                this.checkedCities4.push(item);
              }
              if (e.city === item.code && e.district !== undefined) {
                item.isIndeterminate = true;
              }
              this.isIndeterminateAll = true;
            });
            this.checkedCities4.map(a => {
              if (a.code === item.code) {
                item.checked = a.checked;
              } else if (a.pcode === item.code) {
                // if (item.checked === true) {
                //   item.isIndeterminate = false;
                // }
                item.isIndeterminate = item.checked !== true;
              }
            });
          });
          console.log(this.optionsa);
          this.checkedCities4 = this.unique(this.checkedCities4);
        } else {
          this.optionsb = res.data.data;
          this.optionsb.map(item => {
            item.code = item.code + "";
            item.pcode = item.pcode + "";
            item.checked = data.checked === true;
            // if (data.checked === true) {
            //   item.checked = true;
            // } else {
            //   item.checked = false;
            // }
            this.checkedCities2.map(e => {
              if (item.code + "" === e.district) {
                item.checked = true;
                this.checkedCities4.push(item);
              } else if (item.code + "" === e.pcode) {
                item.isIndeterminate = true;
              }
            });
            this.checkedCities4.map(a => {
              if (a.code === item.code) {
                item.checked = a.checked;
              } else if (a.pcode === item.code) {
                item.isIndeterminate = true;
              }
            });
            this.optionsa.map(s => {
              if (s.code === item.pcode) {
                item.pcode2 = s.pcode2 + "-" + item.code;
                item.cityName = s.cityName + item.name;
              }
            });
          });
          this.checkedCities4 = this.unique(this.checkedCities4);
        }
      });
    },
    handleCheckedCitiesChangea(value) {
      console.log(value, "value", this.checkedCities4, " this.checkedCities4");
      value.isIndeterminate = false;
      if (value.checked) {
        this.checkedCities3.push(value.code + "");
        this.checkedCities4.push(value);

        this.checkedCities4 = this.checkedCities4.filter(
          item => value.code !== item.pcode
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => value.code !== item.pcode2.split("-")[0]
        );
        this.options
          .filter(item => item.checked !== false)
          .map(optionsStr => this.checkedCities4.push(optionsStr));
        this.checkedCities4 = this.unique(this.checkedCities4);
        // this.checkedCities3 = [...new Set(this.checkedCities3)];
        this.checkedCities3 = this.deduoe(this.checkedCities3);
      } else {
        this.checkedCities2 = this.checkedCities2.filter(
          item => item.capital !== value.code
        );
        this.checkedCities3 = this.checkedCities3.filter(
          item => item !== value.code
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.code !== value.code
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => value.code !== item.pcode2.split("-")[0]
        );
        // this.checkedCities4 = this.options.filter(
        //   item => item.checked !== false
        // );
        this.options.map(i => {
          if (i.checked === true) {
            this.checkedCities4.push(i);
          }
        });
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.pcode2 !== "全国"
        );
        this.checkedCities4 = this.unique(this.checkedCities4);
        // }
      }

      if (this.options.every(item => item.checked === true)) {
        this.isIndeterminateAll = false;
        this.checkedAll = true;
        this.checkedCities4 = [{ pcode2: "全国", cityName: "全国" }];
      } else if (this.options.some(item => item.checked === true)) {
        this.isIndeterminateAll = true;
        // this.checkedCities4 = this.options.filter(item => item.checked == true);
        this.checkedAll = false;
      } else {
        this.isIndeterminateAll = false;
        this.checkedAll = false;
        if (this.options.some(item => item.isIndeterminate === true)) {
          this.isIndeterminateAll = true;
        }
      }
      if (this.optionsa.some(item => item.pcode === value.code)) {
        this.optionsa.map(item => item.checked === value.checked);
      }
      this.showBox = false;
      this.showBox2 = false;
      this.options.splice();
      this.checkedCities4 = this.unique(this.checkedCities4);
    },
    handleCheckedCitiesChange2(value) {
      value.isIndeterminate = false;
      if (value.checked) {
        this.checkedCities3.push(value.pcode2);
        // this.checkedCities3 = [...new Set(this.checkedCities3)];
        this.checkedCities3 = this.deduoe(this.checkedCities3);
        this.checkedCities4.push(value);
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.pcode !== value.code
        );
      } else {
        this.checkedAll = false;
        this.checkedCities2 = this.checkedCities2.filter(
          item => item.city !== value.code
        );
        // this.dataInitialized(this.checkedCities2);
        this.checkedCities3 = this.checkedCities3.filter(
          item => item !== value.pcode2
        );
        this.checkedCities3 = this.checkedCities3.filter(item =>
          item.indexOf(value.pcode)
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.code !== value.code
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.pcode !== value.code
        );
        let a = this.options.filter(item => item.checked === true);
        a.map(item => this.checkedCities4.push(item));
      }
      this.options.map(item => {
        if (item.code === value.pcode) {
          if (this.optionsa.every(e => e.checked === true)) {
            item.isIndeterminate = false;
            item.checked = true;
            this.checkedCities4.push(item);
            this.checkedCities4 = this.checkedCities4.filter(
              a => item.code !== a.pcode
            );
          } else if (this.optionsa.some(e => e.checked === true)) {
            item.isIndeterminate = true;
            this.isIndeterminateAll = true;
            item.checked = false;
            let obj1 = this.optionsa.filter(item => item.checked !== false);
            obj1.map(item => this.checkedCities4.push(item));
            let obj = [];
            this.checkedCities4.map(item => obj.push(item.pcode2));
            obj = obj.filter(item => item !== undefined);
            // obj = [...new Set(obj)];
            obj = this.deduoe(obj);
            this.dataInitialized(obj);
            this.checkedCities4 = this.checkedCities4.filter(
              e => e.code !== item.code
            );
          } else {
            if (this.optionsa.some(e => e.isIndeterminate === true)) {
              let obj1 = this.optionsb.filter(item => item.checked !== false);
              let obj2 = this.optionsa.filter(item => item.checked !== false);
              let obj3 = this.options.filter(item => item.checked !== false);
              obj1.map(item => this.checkedCities4.push(item));
              obj2.map(item => this.checkedCities4.push(item));
              obj3.map(item => this.checkedCities4.push(item));
              // (this.optionsa);
              // (this.optionsb);
              // ( this.checkedCities4);
            } else {
              this.isIndeterminateAll = false;
              item.isIndeterminate = false;
              item.checked = false;
            }

            if (this.options.some(s => s.isIndeterminate === true)) {
              this.isIndeterminateAll = true;
            }
          }
        }
      });
      if (this.optionsb.some(item => item.pcode === value.code)) {
        this.showBox2 = false;
        this.optionsb.map(e => e.checked === value.checked);
      }
      if (this.options.every(e => e.checked === true)) {
        console.log(111);
        this.checkedAll = true;
        this.isIndeterminateAll = false;
      }
      this.optionsa.splice();
      this.checkedCities4 = this.unique(this.checkedCities4);
    },
    handleCheckedCitiesChange3(value) {
      if (value.checked) {
        this.checkedCities3.push(value.pcode2);
        this.checkedCities4.push(value);
        this.checkedCities3 = this.deduoe(this.checkedCities3);
      } else {
        this.checkedCities3 = this.checkedCities3.filter(
          item => item !== value.pcode2
        );
        this.checkedCities4 = this.checkedCities4.filter(
          item => item.code !== value.code
        );
        let obj = this.optionsa.filter(item => item.checked === true);
        // this.checkedCities4 = this.options.filter(
        //   item => item.checked === true
        // );
        obj.map(item => this.checkedCities4.push(item));
        // (' this.checkedCities4222222', obj);
      }
      this.optionsa.map(item => {
        if (item.code === value.pcode) {
          if (this.optionsb.every(e => e.checked === true)) {
            item.isIndeterminate = false;
            item.checked = true;
            this.checkedCities4.push(item);
            this.checkedCities4 = this.checkedCities4.filter(
              a => a.pcode !== item.code
            );
            this.options.map(s => {
              if (s.code === item.pcode) {
                if (this.optionsa.every(e => e.checked === true)) {
                  s.isIndeterminate = false;
                  s.checked = true;
                  this.checkedCities4 = this.checkedCities4.filter(
                    a => a.pcode !== s.code
                  );
                  this.checkedCities4.push(s);
                } else if (this.optionsa.some(e => e.checked === true)) {
                  s.isIndeterminate = true;
                  s.checked = false;
                } else {
                  s.isIndeterminate = false;
                  s.checked = false;
                  if (!this.optionsa.some(e => e.checked === true)) {
                    this.isIndeterminateAll = false;
                  }
                }
              }
            });
          } else if (this.optionsb.some(e => e.checked === true)) {
            item.isIndeterminate = true;
            item.checked = false;
            this.checkedCities4 = this.checkedCities4.filter(
              e => e.code !== item.code
            );
            this.options.map(s => {
              if (s.code === item.pcode) {
                s.checked = false;
                s.isIndeterminate = true;
                this.isIndeterminateAll = true;
              }
            });
            let obj1 = this.optionsb.filter(item => item.checked !== false);
            let obj2 = this.optionsa.filter(item => item.checked !== false);
            obj1.map(item => this.checkedCities4.push(item));
            obj2.map(item => this.checkedCities4.push(item));
            let obj = [];
            this.checkedCities4.map(item => obj.push(item.pcode2));
            obj = obj.filter(item => item !== undefined);
            // obj = [...new Set(obj)];
            obj = this.deduoe(obj);
            this.dataInitialized(obj);
            this.checkedCities4 = this.checkedCities4.filter(
              e => e.code !== item.pcode
            );
          } else {
            item.isIndeterminate = false;
            item.checked = false;
            this.options.map(s => {
              if (s.code === item.pcode) {
                if (this.optionsa.some(e => e.checked === true)) {
                  s.isIndeterminate = true;
                  s.checked = false;
                } else if (this.optionsa.every(e => e.checked === true)) {
                  s.isIndeterminate = false;
                  s.checked = true;
                } else if (
                  this.optionsa.every(e => e.isIndeterminate !== true)
                ) {
                  s.isIndeterminate = false;
                  s.checked = false;
                  if (!this.optionsa.some(e => e.checked === true)) {
                    this.isIndeterminateAll = false;
                  }
                  this.checkedCities4 = this.checkedCities4.filter(
                    item => item.checked !== false
                  );
                  let obj1 = [];
                  this.checkedCities4.map(item => {
                    obj1.push(item.pcode2);
                  });
                  this.dataInitialized(obj1);
                  // (' this.checkedCities4222222', this.checkedCities4);
                  // (' this.checkedCities4222222', this.optionsa);
                  // (' this.checkedCities4222222', this.optionsb);
                } else {
                  this.checkedCities4 = this.checkedCities4.filter(
                    item => item.checked !== false
                  );
                  let obj1 = [];
                  this.checkedCities4.map(item => {
                    obj1.push(item.pcode2);
                  });
                  this.dataInitialized(obj1);
                }
              }
            });
            if (this.options.some(s => s.isIndeterminate === true)) {
              this.isIndeterminateAll = true;
            }
          }
        }
      });
      // this.dataInitialized(this.checkedCities3);
      this.optionsb.splice();
      this.checkedCities4 = this.unique(this.checkedCities4);
    },
    change(a, b, c) {},
    show(e, item) {
      // 根据事件处理参数e下的pageX，PageY来定位div的位置
      // 点击的时候显示模态框
      let DOM = e.currentTarget;
      // 获取节点距离浏览器视口的高度
      let top = e.currentTarget.getBoundingClientRect().top;
      // 获取节点距离浏览器视口的宽度
      let left = e.currentTarget.getBoundingClientRect().left;
      // 获取滚动条滚动距离
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      // 两个top相加就是节点真正的top值
      this.showBox = !this.showBox;
      if (this.showBox2) {
        this.showBox2 = this.showBox;
      }
      this.getAddress(item);
      if (parseInt(this.tranLeft, 0) !== parseInt(left, 0) - 80) {
        this.showBox = true;
      }

      // this.tranLeft = e.layerX - 85 + 'px';
      // this.tranTop = e.layerY + 60 + 'px';
      this.tranLeft = left - 80 + "px";
      this.tranTop = top + 26 + "px";
      this.checkedCities4 = this.unique(this.checkedCities4);
    },
    show2(e, item) {
      // 根据事件处理参数e下的pageX，PageY来定位div的位置
      // 点击的时候显示模态框
      let DOM = e.currentTarget;
      // 获取节点距离浏览器视口的高度
      let top = e.currentTarget.getBoundingClientRect().top;
      // 获取节点距离浏览器视口的宽度
      let left = e.currentTarget.getBoundingClientRect().left;
      // 获取滚动条滚动距离
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      // 两个top相加就是节点真正的top值
      if (
        parseInt(this.tranLeft2, 0) > e.layerX - 95 &&
        parseInt(this.tranLeft2, 0) < e.layerX - 75
      ) {
        this.showBox2 = !this.showBox2;
      } else {
        this.showBox2 = !this.showBox2;
      }
      this.tranLeft2 = left + 20 + "px";
      this.tranTop2 = top - 40 + "px";
      // 点击的时候显示模态框
      this.getAddress(item);
      this.checkedCities4 = this.unique(this.checkedCities4);
    },
    handleSelect(item) {
      this.data = item;
    },
    filterArray(data) {
      let filteredData = [];

      for (let i = 0; i < data.length; i++) {
        let currentObj = data[i];
        let isMatched = false;

        for (let j = 0; j < data.length; j++) {
          let compareObj = data[j];

          if (
            currentObj.pcode === compareObj.code &&
            currentObj != compareObj
          ) {
            isMatched = true;
            break;
          }
        }

        if (!isMatched) {
          filteredData.push(currentObj);
        }
      }
      console.log(filteredData, "filteredData");
      return filteredData;
    },
    myCancel() {

      console.log(  this.checkedCities4,'  this.checkedCities4111')
      this.checkedCities4 = this.unique(this.checkedCities4);
      this.showBox = false;
      this.showBox2 = false;
      if (this.options.every(item => item.checked === true)) {
        let code = [];
        this.options.forEach(i => {
          code.push(i.code);
        });
        this.checkedCities4 = [
          { code: code.join(","), cityName: "全国", pcode2: "全国" }
        ];
        this.checkedCities2 = [];
        this.getAddressOfFourth();
        this.isIndeterminateAll = false;
        this.checkedAll = false;
      } else {
        this.checkedCities4 = this.checkedCities4.filter(
          e => e.pcode2 !== "全国"
        );
      }
      this.checkedCities4 = this.filterArray(this.checkedCities4)
      console.log(this.checkedCities4,'筛选后的')
      this.$emit("update:dialogVisible", false);
      this.$emit("myCancel", this.checkedCities4);
      // (' this.checkedCities4222222', this.checkedCities4);
    },
    handleClose() {
      this.showBox = false;
      this.showBox2 = false;
      this.$emit("update:dialogVisible", false);
    },
    handleCheckChange(data) {
      this.data = data;
    },
    changeCheckedAll(val, e) {
      this.showBox = false;
      this.showBox2 = false;
      this.isIndeterminateAll = false;
      if (!val) {
        this.checkedCities4 = [];
        this.checkedCities2 = [];
      } else {
        // this.checkedCities4 = [{ pcode2: '全国', cityName: '全国' }];
      }
      this.options.map(item => {
        item.checked = val;
        item.isIndeterminate = false;
      });
    }
  }
};
</script>
